import React from 'react';
import HelpHint from './HelpHint';

interface CardHeaderProps {
  title: string | React.ReactNode;
  helpKind?: 'kpi' | 'chart' | 'indicator';
  shortText?: string;
  longText?: string;
  helpTitle?: string;
  showWarning?: boolean;
}

const CardHeader: React.FC<CardHeaderProps> = ({ 
  title, 
  helpKind = 'chart',
  shortText,
  longText,
  helpTitle,
  showWarning = false
}) => {
  // Default help texts based on kind
  const getDefaultHelpTexts = (kind: string) => {
    switch (kind) {
      case 'kpi':
        return {
          short: 'Andel elever som uppfyller kriterierna för indikatorn. Värden är jämförbara mellan skolor.',
          long: 'Denna indikator visar resultat för den valda skolan jämfört med kommunens genomsnitt. Källa: Skolverket (Siris).'
        };
      case 'chart':
        return {
          short: 'Staplar visar värden per skola i vald kommun. Jämför Top/Bottom 10 och vald skola.',
          long: 'Grafen visar jämförelse mellan skolor i samma kommun. Skolorna sorteras från högst till lägst värde. Din valda skola markeras med färg.'
        };
      case 'indicator':
        return {
          short: 'Visar information om skolans organisation, personal och elevantal.',
          long: 'Detta indikator visar information om skolans organisation och personal. Källa: Skolverket (Siris).'
        };
      default:
        return {
          short: 'Hjälptext för detta element.',
          long: 'Detaljerad beskrivning kommer här.'
        };
    }
  };

  const defaultTexts = getDefaultHelpTexts(helpKind);
  const finalShortText = shortText || defaultTexts.short;
  const finalLongText = longText || defaultTexts.long;
  const finalHelpTitle = helpTitle || 'Vad visar denna indikator?';

  return (
    <div className="mb-2 flex items-start justify-between">
      <h3 className={`text-sm font-semibold ${showWarning ? 'text-danger' : 'text-foreground'}`}>
        {showWarning && '⚠️ '}{title}
      </h3>
      {(shortText || longText) && (
        <HelpHint 
          kind={helpKind}
          shortText={finalShortText}
          longText={finalLongText}
          title={finalHelpTitle}
        />
      )}
    </div>
  );
};

export default CardHeader;
